import React from "react";
import { useState } from "react";
import DeployCache, {
  isShowCache,
} from "src/components/deployCache/DeployCache";
import { CACHE_DISTRICT } from "src/constants/actionCache";
import DistrictPopup from "../Popup/DistrictPopup";
import ShowCacheDistrict from "../ShowCache/ShowCacheDistrict";

const DistrictControlPanel = ({
  currentActionCache,
  openPopup,
  setOpenPopup,
  recordForEdit,
  addOrEdit,
  handleOpenPopup,
}) => {
  const [disableButton, setDisableButton] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        margin: "20px 0 10px 0",
      }}
    >
      <DeployCache
        title="Cache District"
        isShowButton={isShowCache(currentActionCache, CACHE_DISTRICT)}
      >
        <ShowCacheDistrict
          disableButton={disableButton}
          setDisableButton={setDisableButton}
        />
      </DeployCache>

      <DistrictPopup
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        recordForEdit={recordForEdit}
        addOrEdit={addOrEdit}
        handleOpenPopup={handleOpenPopup}
      />
    </div>
  );
};

export default DistrictControlPanel;
